<template>
  <div class="top-count">
    <div class="list">
      <div :class="['item', item.key]" v-for="(item, i) in countList">
        <span class="name">
          {{ item.name }}
        </span>
        <div class="bottom">
          <i></i>
          <span class="num">
            {{ item.num ? item.num : '-' }}
          </span>
          <span class="unit">
            {{ item.unit ? item.unit : '' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopCount',
  props: {
    type: {
      type: String,
      default: '',
    },
    adCode: {
      type: Number,
      default: 0,
    },
    pointName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      countList: [
        {
          name: '经营主体累计总数',
          key: 'main_body_num',
          num: null,
          unit: ' 万户',
        },
        {
          name: '民营经济占GDP比重',
          key: 'ent_gdp_proportion',
          num: null,
          unit: '%',
        },
        {
          name: '民营税收占全省税收比重',
          key: 'ent_taxation_proportion',
          num: null,
          unit: ' %',
        },
      ],
      numData: {
        total: 2442281,
        company: 1468267,
        team: 61712,
        individuals: 61712,
      },
      countData: {
        累计总数: '67660',
        本年新增: '53209',
        本年注销: '2093',
      },
    };
  },
  watch: {
    type(n) {
      this.getData();
    },
    pointName(n) {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.$api.market.getMarketSubjectStatistics().then((res) => {
        let { data } = res.data.data;
        this.countList = this.countList.map((item) => {
          item.num = data[item.key] ? data[item.key].toLocaleString() : null;
          return item;
        });
      });

      // getMapData(this.type).then(res => {
      //   let name = this.type === 'Country' ? '省份' : '地市';
      //   this.countData = res.filter(item => {
      //     let pointName = this.pointName ? this.pointName : '合计';
      //     return item[name] === pointName
      //   })[0];
      //   this.filterData();
      // })
    },
    filterData() {
      this.countList.map((item) => {
        let val = this.countData[item.name];
        item.num = Number(val);
        if (item.num) {
          item.num = item.num.toLocaleString();
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.top-count {
  width: 881px;
  height: 83px;
  margin: 92px auto 0;
  position: relative;
  padding: 0 84px;
  box-sizing: border-box;
  z-index: 11;
  background: url('~img/market/market-center.png') center center no-repeat;
  background-size: 100%;
}
.list {
  .flex-center();
  justify-content: space-between;
  color: #fff;
  /*padding: 20px 0;*/

  .item {
    width: calc(100% / 3);
    .flex-center();
    flex-direction: column;
    justify-content: center;

    &.membersTotal .bottom i {
      background: url('~img/market/market-center-top0.png') no-repeat;
    }

    &.enterpriseMembersTotal .bottom i {
      background: url('~img/market/market-center-top1.png') no-repeat;
    }

    &.groupMembersTotal .bottom i {
      background: url('~img/market/market-center-top2.png') no-repeat;
    }
  }

  .name {
    font-family: Alibaba PuHuiTi 2;
    font-weight: normal;
    font-size: 20px;
    color: #8ccaff;
    // line-height: 32px;
    // text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
    font-style: italic;
    // background: linear-gradient(0deg, rgba(250, 254, 255, 0.29) 0%, rgba(250, 254, 255, 0) 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
  .bottom {
    .flex-center();
    justify-content: space-between;
    i {
      width: 50px;
      height: 50px;
      display: inline-block;
      background-size: 100% 100% !important;
      margin: -2px 0 0 -12px;
    }
    .num {
      font-family: YouSheTitle;
      font-weight: 400;
      font-size: 26px;
      color: #e4edf7;
      background: linear-gradient(179deg, #afd0e1 20%, #dcf1fb 50%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .unit {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 18px;
      color: rgba(239, 240, 241, 0.6);
      line-height: 1;
    }
  }
}
</style>
